import React, { Component } from "react";
import Routers from "./routes";
import {
  BrowserRouter 
} from "react-router-dom";
import history from "./history";
import Idle from "react-idle";
import Cookies from "universal-cookie";

const cookies = new Cookies();
class App extends Component {
  constructor() {
    super();
    this.state = {
      whiteScreenLoader: true

    };
  }
  componentDidMount() {

    // --------------- ↓↓↓↓↓↓ remove ip condition ↓↓↓↓↓↓  ------------------
    // white listed ip list ↓  ('27.54.182.197', '122.169.113.25' - artoon ip)

    let ipList = JSON.parse(process.env.REACT_APP_WHITELIST_IP)
    // let ipList = ['27.54.182.197', '122.169.113.25', '72.181.125.46', '107.135.63.168', '38.102.20.80', '136.60.130.64', '192.168.86.23', '138.207.158.153', '10.0.0.51', '108.41.32.249', '98.228.244.74',]
    //redirection for elb url to domain name 
    setTimeout(() => {
      if(window.location.host !== 'festival.sundance.org'){
        window.location.href = process.env.REACT_APP_HOME_PAGE + window.location.pathname.substring(1)
      }
    }, 1000);
    if(ipList.length > 0 ){
        let CurrIp
        this.getIP().then(data => CurrIp = data.ip).then(() => {
          console.log(':::::::', ipList.includes(CurrIp))
          if ((window.location.host.includes("festival.sundance.org") || window.location.host.includes('digital.sundance.org') || window.location.host.includes('staginghome.sundance.org') || window.location.host.includes("localhost")) && !ipList.includes(CurrIp)) {
            window.location.href = window.location.origin;
          } else {
            this.setState({ whiteScreenLoader: false })
          }
        }).catch((e) => {
          window.location.href = window.location.origin;
          this.setState({ whiteScreenLoader: false })
        })
    }else this.setState({ whiteScreenLoader: false })

    // --------------- ↑↑↑↑↑↑ remove ip condition ↑↑↑↑↑↑  ------------------

    // if(window.location.pathname !== "/howtofest/" && window.location.hostname !== 'localhost'){
    //   window.location.href = `${(window.location.origin + "/howtofest/") + window.location.pathname.replace("/howtofest/","")}`
    // }
    
    setInterval(function() {
        let User = cookies.get("SundanceNewUser") || cookies.get("particularNewUser")
        if (User) {
          let currDate = new Date();
          let Time = process.env.REACT_APP_IDLE_LOGOUT_TIME
          currDate.setTime(currDate.getTime() + (JSON.parse(Time)));
          cookies.set("SundanceNewUser", User, {domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/", expires: currDate });
        }
      }, 10000);
   
    
  }
  // scrollTopFn = () => {
  //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  // }
  logout = () => {
    let LoginUser =
      cookies.get("SundanceNewUser") || cookies.get("particularNewUser");
    if (LoginUser && LoginUser.token) {
      // eslint-disable-next-line
      document.cookie =
        "SundanceNewUser" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      cookies.remove("SundanceNewUser", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
      });

      // eslint-disable-next-line
      document.cookie =
        "particularNewUser" +
        "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      cookies.remove("particularNewUser", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
      });

      document.cookie =
        "CartCount" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      cookies.remove("CartCount", {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
      });

      let Zone = localStorage.getItem('TIMEZONE')
        localStorage.clear();
      if(Zone) localStorage.setItem('TIMEZONE', Zone)
      window.location.reload();
      window.open(process.env.REACT_APP_HOME_URL + "sign-in", "_self");
    }
  };

  async getIP() {
    this.setState({
      whiteScreenLoader: true
    })
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    return response.status === 200 ? data : "err"
  }

  render() {
    return (
      <BrowserRouter basename="how-to-fest">
        <Idle timeout={process.env.REACT_APP_IDLE_LOGOUT_TIME} render={({ idle }) =><h1>{idle ? this.logout() : "" }</h1>} />
        {this.state.whiteScreenLoader ? <></> : <Routers history={history} />}
        {/* --------------- ↑↑↑↑↑↑ remove whiteScreenLoader condition ip condition ↑↑↑↑↑↑  ------------------ */}
      </BrowserRouter>
    )
  }
}

export default App;
